import  React, {use, useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import './styles/estandar/FormStyle.css';
import './styles/Formulario_registro.css';
import axios from 'axios';
import { CgWebcam } from 'react-icons/cg';
import { AiOutlineKey } from 'react-icons/ai';
import MensajeError from '../components/MensajeError';
import MensajeAlerta from '../components/MensajeAlerta';
import MenuBar from '../components/MenuBar';
import Cookies from 'js-cookie';
import { IoMdArrowRoundBack } from "react-icons/io";

import { useConfig } from '../contexts/ConfigContext';



//RepPrA
const Formulario_registro = () =>{
    const navigate = useNavigate();

    const config = useConfig();
    const API_URL = `${config.API_URL}`;

    const [year, setYear] = useState('');
    const [relacion, setRelacion] = useState('');
    const [registro, setRegistro] = useState('');
    const [boleta, setBoleta] = useState('');
    const [nombre, setNombre] = useState('');
    const [numero_expediente, setNumero_expediente] = useState('');
    const [carrera, setCarrera] = useState('');
    const [prestatario, setprestatario] = useState('');
    const [area, setArea] = useState('');
    const [profesor, setProfesor] = useState('');
    const [fecha_inicio, setFecha_inicio] = useState('');
    const [fecha_fin, setFecha_fin] = useState('');
    const [tipo, setTipo] = useState('');
    const [creditos, setCreditos] = useState('');
    const [horario, setHorario] = useState('');
    const [obs, setObs] = useState('');
    const [carta_compromiso, setCarta_compromiso] = useState(false);
    const [fecha_carta_compromiso, setFecha_carta_compromiso]  = useState(null);
    const [nombre_persona_recibido, setNombre_persona_recibido] = useState('');


    /*ERRORES VARIABLES*/
    const [yearError, setYearError] = useState('');
    const [relacionError, setRelacionError] = useState('');
    const [registroError, setRegistroError] = useState('');
    const [boletaError, setBoletaError] = useState('');
    const [nombreError, setNombreError] = useState('');
    const [numero_expedienteError, setNumero_expedienteError] = useState('');
    const [carreraError, setCarrerError] = useState('');
    const [prestatarioError, setprestatarioError] = useState('');
    const [areaError, setAreaError] = useState('');
    const [profesorError, setProfesorError] = useState('');
    const [fecha_inicioError, setFecha_inicioError] = useState('');
    const [fecha_finError, setFecha_finError] = useState('');
    const [tipoError, setTipoError] = useState('');
    const [creditosError, setCreditosError] = useState('');
    const [horarioError, setHorarioError] = useState('');
    const [obsError, setObsError] = useState('');
    const [carta_compromiso_error, setCarta_compromiso_error] = useState('');
    const [fecha_carta_compromiso_error, setFecha_carta_compromiso_error] = useState('');
    const [nombre_persona_recibido_error, setNombre_persona_recibido_error] = useState('');

//Mensaje generico de error
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    //Mensaje de alerta
    const [showAlerta, setShowAlerta] = useState(false);
    const [MsgAlerta, setMsgAlerta] = useState('');


    /*Funcion para validar el tipo de session*/
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid === "rid2"){
                    navigate("/Home");
                }else{
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");

                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }
    }

    useEffect(() =>{
        validarSesion();  
    },[])



    const limpiarErrores = ()=>{
        setYearError('');
        setRelacionError('');
        setRegistroError('');
        setBoletaError('');
        setNombreError('');
        setNumero_expedienteError('');
        setCarrerError('');
        setprestatarioError('');
        setAreaError('');
        setProfesorError('');
        setFecha_inicioError('');
        setFecha_finError('');
        setTipoError('');
        setCreditosError('');
        setHorarioError('');
        setObsError('');
        setCarta_compromiso_error('');
        setFecha_carta_compromiso_error('');
        setNombre_persona_recibido_error('');
    }

    const setearErrores = (jsonErrores) =>{
        for(const field in jsonErrores){
            if(jsonErrores.hasOwnProperty(field)){
                 const errorMessage = jsonErrores[field][0];

                 switch(field){
                    case '$.ano':
                        setYearError(errorMessage);
                        break;
                    case 'ano':
                        setYearError(errorMessage);
                        break;
                    case 'relacion':
                        setRelacionError(errorMessage);
                        break;
                    case 'registro':
                        setRegistroError(errorMessage);
                        break;
                    case 'boleta':
                        setBoletaError(errorMessage);
                        break;
                    case 'nombre':
                        setNombreError(errorMessage);
                        break;
                    case 'numero_expediente':
                        setNumero_expedienteError(errorMessage);
                        break;
                    case 'carrera':
                        setCarrerError(errorMessage);
                        break;
                    case 'prestatario':
                        setprestatarioError(errorMessage);
                        break;
                    case 'area':
                        setAreaError(errorMessage);
                        break;
                    case 'profesor':
                        setProfesorError(errorMessage);
                        break;
                    case 'periodo_fecha_inicio':
                        setFecha_inicioError(errorMessage);
                        break;
                    case 'periodo_fecha_fin':
                        setFecha_finError(errorMessage);
                        break;
                    case 'tipo':
                        setTipoError(errorMessage);
                        break;
                    case 'creditos':
                        setCreditosError(errorMessage);
                        break;
                    case 'horario':
                        setHorarioError(errorMessage);
                        break;
                    case 'obs':
                        setObsError(errorMessage);
                        break;
                    case 'carta_compromiso':
                        setCarta_compromiso_error(errorMessage);
                    case 'fecha_carta_compromiso' || '$.fecha_carta_compromiso':
                        setFecha_carta_compromiso_error(errorMessage);
                    case 'nombre_recibido_carta':
                        setNombre_persona_recibido_error(errorMessage);
                    default:
                        console.warn('Error campo desconocido');
                 }
            }
        }
    }

    const crearRegistro = async(e) =>{

        e.preventDefault();

        const formularioData = {
            ano: year,
            relacion: relacion,
            boleta: boleta,
            nombre: nombre,
            numero_expediente: numero_expediente,
            carrera: carrera,
            prestatario: prestatario,
            area:area,
            profesor:profesor,
            periodo_fecha_inicio:fecha_inicio,
            periodo_fecha_fin:fecha_fin,
            tipo:tipo,
            registro: registro,
            creditos:creditos,
            horario:horario,
            carta_compromiso:carta_compromiso,
            fecha_carta_compromiso:fecha_carta_compromiso,
            nombre_recibido_carta: nombre_persona_recibido,
            obs:obs
        }
        console.log(formularioData);

        limpiarErrores();

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );


        try{
            const response = await axios.post(API_URL + '/api/registro/crear', formularioData, {Authorization: true});

             if(response.status >= 200 && response.status < 300){
                //setEstado_ventana(response.data.mensaje);    
                //alert(response.data.mensaje);
                //navigate('/Home')
                setShowAlerta(true);
                setMsgAlerta(response.data.mensaje);
            }else{
                 //setStatusMessage(`Error inesperado: ${response.status} ${response.statusText}`);
                 //alert(`Error inesperado: ${response.status} ${response.statusText}`);
                 setErrorMessage(`Error inesperado: ${response.status} ${response.statusText}`);
                 setShowError(true);
            }
        }catch(error){
            if(axios.isAxiosError(error)){
                if(error.response){
                    var jsonRespuesta = error.response.data;
                    setearErrores(jsonRespuesta["errors"]);
                }else if(error.request){
                    console.error('No se recibió respuesta del backend:', error.request);
                    setErrorMessage('No se recibió respuesta del backend:' + error.request);
                    setShowError(true);
                }else{
                    console.error('Error al configurar la solicitud:', error.message);
                    setErrorMessage('Error al configurar la solicitud:'+ error.message);
                    setShowError(true);
                }
            }else{
                console.error('Error desconocido:', error);
                setErrorMessage(error);
                setShowError(true);
            }
        }
    }

    const handleRegresar = () =>{
        navigate('/Home');
    }


    const handleCloseError = () => {
        setShowError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setErrorMessage(''); // Opcional: limpia el mensaje de error
    };

    const marcar_carta = (event) =>{
        setCarta_compromiso(event.target.checked);
    }

    return(
        <div className='rootFormularioRegistro'>
             <MensajeError mensaje={errorMessage} show={showError} onClose={handleCloseError}/>
             <MensajeAlerta mensaje={MsgAlerta} show={showAlerta} onClose={handleRegresar}/>
             <div className="mainBoxFormularioRegistro">

                
                <div id='colorBarFormularioRegistro'></div>
                <div className="registroFormBox">
                    <h1>Registar alumno</h1>
                    <button className='regresarMenuPrincipal' onClick={handleRegresar}><IoMdArrowRoundBack color='white' size="18px"/></button>
                
                
                
                <form className='registroForm' onSubmit={crearRegistro}>
                    <label htmlFor="year" className='labelF'>Año</label>
                    <input type="text" placeholder="Año.." id='year' name="year" className="inputF" value={year} onChange={(e)=>setYear(e.target.value)} required/>
                    {yearError && <p className='errorMsg'>*{yearError}</p>}
                    

                    <label htmlFor='relacion' className='labelF'>Relaci&oacute;n</label>
                    <input type='text' placeholder="Relacion..."  id='relacion' name='relacion' className="inputF" value={relacion} onChange={(e)=>setRelacion(e.target.value)}/>
                    {relacionError && <p className='errorMsg'>*{relacionError}</p>}


                    <label htmlFor='registro' className='labelF'>Registro</label>
                    <input type='text' placeholder="Registro"  id='registro' name='registro' className="inputF" value={registro} onChange={(e)=>setRegistro(e.target.value)}/>
                    {registroError && <p className='errorMsg'>*{registroError}</p>}

                    <label htmlFor='boleta' className='labelF'>Boleta</label>
                    <input type='text' placeholder="Boleta..."  id='boleta' name='boleta' className="inputF" value={boleta} onChange={(e)=>setBoleta(e.target.value)}/>
                    {boletaError && <p className='errorMsg'>*{boletaError}</p>}

                    <label htmlFor='nombre' className='labelF'>Nombre</label>
                    <input type='text' placeholder="Nombre..."  id='nombre' name='nombre' className="inputF" value={nombre} onChange={(e)=>setNombre(e.target.value)}/>
                    {nombreError && <p className='errorMsg'>*{nombreError}</p>}

                    <label htmlFor='numero_expediente' className='labelF'>Numero de expediente</label>
                    <input type='text' placeholder="Expediente.."  id='numero_expediente' name='numero_expediente' className="inputF" value={numero_expediente} onChange={(e) => setNumero_expediente(e.target.value)}/>
                    {numero_expedienteError && <p className='errorMsg'>*{numero_expedienteError}</p>}

                    <label htmlFor='carrera' className='labelF'>Carrera</label>
                    <input type='text' placeholder="Carrera..."  id='carrera' name='carrera' className="inputF" value={carrera} onChange={(e)=> setCarrera(e.target.value)}/>
                    {carreraError && <p className='errorMsg'>*{carreraError}</p>}

                    <label htmlFor='prestatario' className='labelF'>Prestatario</label>
                    <input type='text' placeholder='prestatario' id='prestatario' name='prestatario' className='inputF' value={prestatario} onChange={(e)=>setprestatario(e.target.value)}/>
                    {prestatarioError && <p className='errorMsg'>*{prestatarioError}</p>}

                    <label htmlFor='area' className='labelF'>Area</label>
                    <input type='text' placeholder='area' id='area' name='area' className='inputF' value={area} onChange={(e)=>setArea(e.target.value)}/>
                    {areaError && <p className='errorMsg'>*{areaError}</p>}

                    <label htmlFor='profesor' className='labelF'>Profesor</label>
                    <input type='text' placeholder='profesor' id='profesor' name='profesor' className='inputF' value={profesor} onChange={(e)=>setProfesor(e.target.value)}/>
                    {profesorError && <p className='errorMsg'>*{profesorError}</p>}

                    <label htmlFor='fecha_inicio' className='labelF'>Fecha de inicio</label>
                    <input type="date" placeholder='fecha inicio' id='fecha_inicio' name='fecha_inicio' className='inputF' value={fecha_inicio} onChange={(e)=>setFecha_inicio(e.target.value)} required/>
                    {fecha_inicioError && <p className='errorMsg'>*{fecha_inicioError}</p>}

                    <label htmlFor='fecha_fin' className='labelF'>Fecha de finalizaci&oacute;n</label>
                    <input type="date" placeholder='fecha fin' id='fecha_fin' name='fecha_fin' className='inputF' value={fecha_fin} onChange={(e)=>setFecha_fin(e.target.value)} required/>
                    {fecha_finError && <p className='errorMsg'>*{fecha_finError}</p>}

                    <label htmlFor='tipo' className='labelF'>Tipo</label>
                    <input type='text' placeholder='tipo' id='tipo' name='tipo' className='inputF' value={tipo} onChange={(e)=>setTipo(e.target.value)}/>
                    {tipoError && <p className='errorMsg'>*{tipoError}</p>}

                    <label htmlFor='creditos' className='labelF'>Creditos</label>
                    <input type='text' placeholder='creditos' id='creditos' name='creditos' className='inputF' value={creditos} onChange={(e)=>setCreditos(e.target.value)}/>
                    {creditosError && <p className='errorMsg'>*{creditosError}</p>}

                    <label htmlFor='horario' className='labelF'>Horario</label>
                    <input type='text' placeholder='horario' id='horario' name='horario' className='inputF' value={horario} onChange={(e)=>setHorario(e.target.value)}/>
                    {horarioError && <p className='errorMsg'>*{horarioError}</p>}

                    <label htmlFor='OBS' className='labelF'>OBS</label>
                    <input type='text' placeholder='OBS' id='OBS' name='OBS' className='inputF' value={obs} onChange={(e)=>setObs(e.target.value)}/>
                    {obsError && <p className='errorMsg'>*{obsError}</p>}


                    <div className='checkBoxCustom'>
                        <div class="checkbox-wrapper-3">
                            <input type="checkbox" id="cbx-3" checked={carta_compromiso} onChange={marcar_carta}/>
                            <label for="cbx-3" class="toggle"><span></span></label>
                        </div>
                        <label className='labelFCheckbox'>Carta Compromiso</label>
                        {carta_compromiso_error && <p className='errorMsg'>*{carta_compromiso_error}</p>}
                    </div>
                    {carta_compromiso  &&
                        <div className='dateCartaCompromis'>
                            <label className='labelF' htmlFor='fecha_carta_comp'>Fecha de recibido de la carta de compromiso</label>
                            <input type='date' className='inputF' name='fecha_carta_comp' value={fecha_carta_compromiso} onChange={(e)=>setFecha_carta_compromiso(e.target.value)}/>
                            {fecha_carta_compromiso_error &&<p className='errorMsg'>*{fecha_carta_compromiso_error}</p> }
                            <label className='labelF' htmlFor='nombre_recibido_carta'>Nombre de la persona que recibi&oacute; la carta</label>
                            <input type='text' className='inputF' name='nombre_recibido_carta' value={nombre_persona_recibido} onChange={(e)=>setNombre_persona_recibido(e.target.value)}/>
                            {nombre_persona_recibido_error && <p className='errorMsg'>*{nombre_persona_recibido_error}</p>}


                        </div>
                        
                    }
                    
  
                    
                    <button className='buttonStandartR' id='registrarBtn' type='submit'>Registrar</button>

                </form>
            </div>
        </div>

        </div>
       
    );
}

export default Formulario_registro;